module.exports = __webpack_public_path__ + "5b9ec2907ae22244c68e5cc2a6c99977.svg";